// extracted by mini-css-extract-plugin
export default {"adSlider":"AdSlider_adSlider__1ZNd5","adSliderTrack":"AdSlider_adSliderTrack__gqrjo","scroll":"AdSlider_scroll__yoMb+","slideImg":"AdSlider_slideImg__EP3lU"};